import axios from "axios";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";



const xmlPresignUrl = async (xmlId, prefix) => {
    try {
        const token = await getOrRefreshFirebaseToken();
        // Define the endpoint URL
        const url = `${prefix}xml/${xmlId}/presigned-url`;
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        }; 
        // Make the POST request using axios
        const response = await fetch(url, {
            method: "GET",
            headers: headers,
        });  
        
        
    
        // Check if the response is successful
        if (response.status === 200) {
        let xml_url = await response.text(); // Return the presigned URL
        return xml_url.trim().replace(/"/g, ""); // Clean up the URL
        } else {
        throw new Error(`Failed to get presigned URL: ${response.status}`);
        }
    } catch (error) {
        console.error("Error in xmlPresignUrl:", error);
        throw error; // Re-throw the error for further handling
    }
}

export default xmlPresignUrl;